import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import AdminLayout from "./layouts/Admin";
import DefaultLayout from "./layouts/Default";
import ReviewerLayout from "./layouts/Reviewer";
import UserLayout from "./layouts/User";

// Route Views
import AdminPanel from "./views/AdminPanel";
import { Analytics } from "./views/Analytics";
import Errors from "./views/Errors";
import NewHistoric from "./views/NewHistoric";
import NotAuth from "./views/NotAuth";
import Overview from "./views/Overview";
import PredictionGraph from "./views/PredictionGraph";
import SignUp from "./views/SignUp";
import UserProfileLite from "./views/UserProfile";
import UploadReports from "./views/UploadReports";
import PresentationView from "./views/PresentationView";

//TODO: maybe depending on user
export default () => {
  return [
    {
      path: "/",
      exact: true,
      layout: DefaultLayout,
      component: () => <Redirect to="/overview" />,
    },
    {
      path: "/overview",
      layout: DefaultLayout,
      component: Overview,
    },
    {
      path: "/profile",
      layout: UserLayout,
      component: UserProfileLite,
    },
    {
      path: "/admin-panel",
      layout: AdminLayout,
      component: AdminPanel,
    },
    /*{
          path: "/historical",
          layout: DefaultLayout,
          component: Historic
        },*/
    {
      path: "/register",
      layout: AdminLayout,
      component: SignUp,
    },
    {
      path: "/not-auth",
      layout: DefaultLayout,
      component: NotAuth,
    },
    {
      path: "/error",
      layout: Errors,
      component: NotAuth,
    },
    {
      path: "/new-historic",
      layout: AdminLayout,
      component: NewHistoric,
    },
    {
      path: "/new-bovine-price",
      layout: DefaultLayout,
      component: Analytics,
    },
    {
      path: "/review",
      layout: ReviewerLayout,
      component: PredictionGraph,
    },
    {
      path: "/upload-reports",
      layout: AdminLayout,
      component: UploadReports,
    },
    { path: "/presentation", 
      layout: DefaultLayout, 
      component: PresentationView 
    },
    {
      layout: DefaultLayout,
      component: Errors,
    },
  ];
};
